import { useEffect, useRef } from 'react'
import FilterChip from './FilterChip'
import { ConfigFiltersLayoutProps } from '../types'

interface FilterChipBarProps extends ConfigFiltersLayoutProps {
    selectedTitle: string;
    onSelect: (title: string) => void;
}

const FilterChipBar = ({ chainColumns, independentColumns, selectedTitle, onSelect }: FilterChipBarProps) => {
    const containerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const container = containerRef.current
        const chip = container?.querySelector<HTMLElement>('[aria-pressed="true"]')
        if (!container || !chip) return

        const containerRect = container.getBoundingClientRect()
        const chipRect = chip.getBoundingClientRect()
        const offset = chipRect.left - containerRect.left - (containerRect.width - chipRect.width) / 2
        container.scrollBy({ left: offset, behavior: 'smooth' })
    }, [selectedTitle])

    return (
        <div ref={containerRef} className='px-4 py-3 flex flex-row gap-3 overflow-auto border-b border-brand-green-7'>
            {chainColumns.map((col) =>
                <FilterChip
                    key={col.title}
                    column={col}
                    selected={col.title === selectedTitle}
                    onClick={() => onSelect(col.title)}
                    disabled={!col.visible}
                />
            )}
            <div className='border-l border-brand-green-9 shrink-0'></div>
            {/* ODS y grupos prioritarios siempre quedan habilitados */}
            {independentColumns.map((col) =>
                <FilterChip
                    key={col.title}
                    column={col}
                    selected={col.title === selectedTitle}
                    onClick={() => onSelect(col.title)}
                />
            )}
        </div>
    )
}

export default FilterChipBar
